import styled from '@emotion/styled';
import { css } from 'emotion';

import { getThemeColor } from '@ezugi/ui/theme';
import { DeviceInfo } from '@ezugi/utils';

export const Container = styled.div`
  background: transparent;
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

export const mobile = css`
  background: transparent;
  position: fixed;
  bottom: calc(env(safe-area-inset-bottom) + 43px);
  width: 100%;
`;

export const vertical = css`
  width: auto;
  height: 100%;
  pointer-events: none;

  ${DeviceInfo.isHandheld ? `
    position: fixed;
    right: calc(env(safe-area-inset-right) + 4px);
    top: 0;
    bottom: auto;
  ` : ''}
`;

export const BetTools = styled.div`
  position: relative;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
`;

export const mobileBetTools = css`
  background: transparent;
  margin: 0;
`;

export const verticalBetTools = css`
  flex-flow: column;
  height: 100%;
  pointer-events: none;
`;

export const Spacer = styled.span`
  flex: none;
  height: 1px;
  opacity: 0;
`;

export const chipSelector = css`
  z-index: 1;
  font-family: 'Roboto Condensed', Montserrat, Roboto, sans;
`;

export const hiddenClassName = css`
  opacity: 0;
`;

export const withProgressContainer = css`
  background: ${DeviceInfo.isHandheld ? 'transparent' : getThemeColor('background', 0.8)};
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  bottom: 0px;
`;

export const progressBar = css`
  border-radius: 10px;
  width: 100%;
`;

export const progressBetToolsDesktop = css({
  margin: 16,
});
